import { render, staticRenderFns } from "./PixellotSidebar.vue?vue&type=template&id=78b0a15e&lang=pug&"
import script from "./PixellotSidebar.vue?vue&type=script&lang=js&"
export * from "./PixellotSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PixellotSidebar.vue?vue&type=style&index=0&id=78b0a15e&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b0a15e')) {
      api.createRecord('78b0a15e', component.options)
    } else {
      api.reload('78b0a15e', component.options)
    }
    module.hot.accept("./PixellotSidebar.vue?vue&type=template&id=78b0a15e&lang=pug&", function () {
      api.rerender('78b0a15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PixellotSidebar.vue"
export default component.exports